import { ZfDialog, ZfDialogContent, ZfDialogHeader } from '@zafire/react';
import React from 'react';
import {
  ConfigureProductModalFooter,
  ConfigureProductModalFooterProps,
} from '../components/ConfigureProductModalFooter';

type Props = {
  title: string;
  width: string;
  size: 'small' | 'large';
  editor?: React.ReactNode;
  isPending: boolean;
  onClose: () => void;
  footer: Omit<ConfigureProductModalFooterProps, 'onClose' | 'isPending'>;
  children?: React.ReactNode;
};

export const ConfigureProductDialog: React.FC<Props> = ({
  title,
  width,
  size,
  editor,
  isPending,
  onClose,
  footer,
  children,
}) => (
  <ZfDialog
    show={true}
    size={size}
    style={{ width, maxWidth: 'calc(100vw - 48px)', maxHeight: '100vh' }}
    disableLightDismiss={isPending}
    onDialogClose={onClose}
  >
    <ZfDialogHeader showCloseButton={!isPending}>{title}</ZfDialogHeader>
    <ZfDialogContent>
      {editor}
      {children}
    </ZfDialogContent>
    <ConfigureProductModalFooter {...footer} isPending={isPending} onClose={onClose} />
  </ZfDialog>
);
